







































import InputTextFocusable from "@/edinet/search2/InputTextFocusable.vue";
import LangButton from "@/set/home/LangButton.vue";
import {isVerySmallScreen} from "@/set/search/ScreenUtils";
import {SearchHistory, SetState} from "@/set/set_store";
import Vue from 'vue'
import {mapGetters, mapMutations, mapState} from "vuex"

export default Vue.extend({
  components: {
    LangButton,
    InputTextFocusable
  },
  props: {
    sym: String,
    title: String,
    titleHref: String,
    showTitle: Boolean
  },
  data() {
    return {
      symInput: this.sym,
      forceRefresh: this.$route.query.refresh ? this.$route.query.refresh : false,
      loading: false,
      error: '',

      currentIndex: {
        id: '',
        srcLocation: '',
        meta: {}
      },
      showAllNews: true,
      docHref: '',
      docUrls: [] as string[],
      viewerSettings: {
        viewer: 'MS',
        padding: true
      }
    }
  },
  computed: {
    ...mapState('set', {
      lang: state => (state as SetState).lang,
      useGoogleDriveViewer: state => (state as SetState).useGoogleDriveViewer
    }),
    ...mapGetters('set', ['historyReversed']),
    showHistory(): boolean {
      return !isVerySmallScreen()
    },
    filteredHistory(): SearchHistory[] {
      return this.historyReversed.filter((x: SearchHistory) => x.sym !== this.sym)
    },
    hrefs(): { news: string; company: string; shareholders: string; rights: string; price: string; chart: string; guruf: string } {
      const sym = this.sym
      const lang = (this.lang === 'th') ? 'language=th&country=TH' : 'language=en&country=US'
      return {
        news: `https://classic.set.or.th/set/companynews.do?symbol=${sym}&ssoPageId=8&${lang}`,
        company: `https://classic.set.or.th/set/factsheet.do?symbol=${sym}&ssoPageId=3&${lang}`,
        shareholders: `https://classic.set.or.th/set/companyholder.do?symbol=${sym}&ssoPageId=6&${lang}`,
        rights: `https://classic.set.or.th/set/companyrights.do?symbol=${sym}&ssoPageId=7&${lang}`,
        price: `https://marketdata.set.or.th/mkt/stockquotation.do?symbol=${sym}&ssoPageId=1&${lang}`,
        chart: `https://www.tradingview.com/symbols/SET-${sym}/`,
        guruf: `https://www.gurufocus.com/stock/BKK:${sym}/summary`
      }
    },
    isVerySmallScreen: isVerySmallScreen
  },
  methods: {
    ...mapMutations('set', ['toggleUseGoogleDriveViewer']),
    changeUseGoogleDriveViewer(value: string) {
      console.log(value)
      this.toggleUseGoogleDriveViewer()
    },
    customTitleStyle() {
      const w = Math.max(Math.min(window.innerWidth - 600, 500), 200)
      return `max-width:${w}px`
    },
    search() {
      this.symInput = this.symInput.toUpperCase()
      const newPath = `/set/${this.symInput}`
      if (this.forceRefresh) {
        this.$router.push({path: newPath, query: {refresh: 'true'}})
        this.$router.go(0)
      } else {
        this.$router.push({path: newPath})
        this.$router.go(0)
      }
    },
    refresh() {
      this.$router.go(0)
    }
  }
})
